import PropTypes from 'prop-types';

export const schedulePaymentPropTypes = {
	from: PropTypes.string.isRequired,
	to: PropTypes.string.isRequired,
	sort_code: PropTypes.string.isRequired,
	account_number: PropTypes.string.isRequired,
	mandateType: PropTypes.string.isRequired,
	when: PropTypes.string.isRequired,
	reference: PropTypes.string,
	amount: PropTypes.string.isRequired,
};
export const standingOrderPropTypes = {
	...schedulePaymentPropTypes,
	frequency: PropTypes.string.isRequired,
	numberOfTimes: PropTypes.number,
	endWhen: PropTypes.string,
	stopWhen: PropTypes.string.isRequired,
};
export const directDebitPropTypes = {
	...schedulePaymentPropTypes,
};
export const bacsPaymentProptypes = {
	amount: PropTypes.number.isRequired,
	mandateType: PropTypes.string.isRequired,
	bacsId: PropTypes.string.isRequired,
	submissionDate: PropTypes.string.isRequired,
	settlementDate: PropTypes.string.isRequired,
	creator_name: PropTypes.string.isRequired,
	created_timestamp: PropTypes.string,
	fromAccount: PropTypes.shape({
		displayName: PropTypes.string.isRequired,
		accountNumber: PropTypes.string.isRequired,
		sortCode: PropTypes.string.isRequired,
		accountHolder: PropTypes.string,
	}).isRequired,
	numberOfPayments: PropTypes.number.isRequired,
};

export const chapsPaymentPropTypes = {
	mandate: PropTypes.shape({
		mandateType: PropTypes.string.isRequired,
		created_by: PropTypes.string.isRequired,
		created_timestamp: PropTypes.string.isRequired,
		rawAmount: PropTypes.shape({
			value: PropTypes.number.isRequired,
			currency: PropTypes.string.isRequired,
		}),
		reference: PropTypes.string,
		charge: PropTypes.shape({
			value: PropTypes.string.isRequired,
			currency: PropTypes.string.isRequired,
		}),
		fromAccount: PropTypes.shape({
			accountHolder: PropTypes.string.isRequired,
			accountId: PropTypes.string.isRequired,
			accountNumber: PropTypes.string.isRequired,
			displayName: PropTypes.string.isRequired,
			number: PropTypes.string.isRequired,
			sortCode: PropTypes.string.isRequired,
			type: PropTypes.string.isRequired,
		}),
		to_account: PropTypes.shape({
			name: PropTypes.string.isRequired,
			account_number: PropTypes.string.isRequired,
			sort_code: PropTypes.string.isRequired,
		}),
		submission_date: PropTypes.string.isRequired,
	}),
};
